import { HStack, Link } from 'govwell-ui'
import parse, { DOMNode, domToReact } from 'html-react-parser'
import { twMerge } from 'tailwind-merge'

import ParsedHtmlButton from 'src/pages/AIChat/AIResponseMessage/ParsedHtmlButton'

type Props = {
  html: string
  index?: number
  handleAIChat?: (text: string) => void
  shouldDisableButtons?: boolean
  className?: string
}

const ParsedHtmlMessage = (props: Props) => {
  const { html, index, handleAIChat, shouldDisableButtons, className } = props
  return (
    <div
      className={twMerge(
        'leading-6 whitespace-normal',
        '[&_li]:mb-0.5',
        '[&_ol]:mx-1.5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5',
        '[&_p]:m-1.5',
        '[&_ul]:mx-1.5 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5',
        '[&>div]:mx-2.5 [&>div]:my-1.5',
        className
      )}
    >
      {parse(html, {
        replace: (node: DOMNode) => {
          if (node.type === 'tag' && node.name === 'a') {
            return (
              <Link externalHref={node.attribs.href ?? ''} className="font-normal">
                {domToReact(node.children as DOMNode[])}
              </Link>
            )
          }
          if (node.type === 'tag' && node.name === 'buttonrow') {
            return (
              <HStack gap={2} wrap="wrap" className="mt-3">
                {domToReact(node.children as DOMNode[], {
                  replace: (child: DOMNode, childIndex: number) => {
                    if (
                      child.type === 'tag' &&
                      child.name === 'button' &&
                      child.attribs?.['data-chat-text']
                    ) {
                      const id = `ai-chat-button-${index}-${childIndex}`
                      return (
                        <ParsedHtmlButton
                          key={id}
                          id={id}
                          node={child}
                          handleAIChat={handleAIChat}
                          shouldDisableButtons={shouldDisableButtons}
                        />
                      )
                    }
                  },
                })}
              </HStack>
            )
          }
        },
      })}
    </div>
  )
}

export default React.memo(ParsedHtmlMessage)
